const envCheck = () => {
  const currUrl = window.location.href;

  if (currUrl.includes("localhost")) {
    return "LOCAL";
  } else if (currUrl.includes("dev-owfsa")) {
    return "DEV";
  } else if (currUrl.includes("qa-owfsa")) {
    return "QA";
  } else if (currUrl.includes("stage-owfsa")) {
    return "STAGE";
  } else if (currUrl.startsWith("https://owfsa.westjet.com")) {
    return "";
  } else {
    throw new Error("Unsupported environment");
  }
};

export default function useEnvCheck() {
  return {
    envCheck,
  };
}
